import { render } from "./BaseCard.vue?vue&type=template&id=1715f9fa&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.css?vue&type=style&index=0&id=1715f9fa&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1715f9fa"]])

export default __exports__